/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsAcceptanceRouteImport } from './routes/terms-acceptance'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as JoinRequestsRouteImport } from './routes/join-requests'
import { Route as HomeRouteImport } from './routes/home'
import { Route as FundingRouteImport } from './routes/funding'
import { Route as DevToolsRouteImport } from './routes/dev-tools'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as BatchProcessesRouteImport } from './routes/batch-processes'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StaffIndexRouteImport } from './routes/staff/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as RosterIndexRouteImport } from './routes/roster/index'
import { Route as ReportingIndexRouteImport } from './routes/reporting/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as PayoutRequestsIndexRouteImport } from './routes/payout-requests/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as OppsIndexRouteImport } from './routes/opps/index'
import { Route as InvitationsIndexRouteImport } from './routes/invitations/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as FundingIndexRouteImport } from './routes/funding/index'
import { Route as UnpaidCompletedWorkReportDownloadsIdRouteImport } from './routes/unpaid-completed-work-report-downloads/$id'
import { Route as SystemOrglessAccountsRouteImport } from './routes/system/orgless-accounts'
import { Route as SystemClassifyDomainRouteImport } from './routes/system/classify-domain'
import { Route as RosterAddRouteImport } from './routes/roster/add'
import { Route as ReportingPayoutsRouteImport } from './routes/reporting/payouts'
import { Route as ReportingCashflowRouteImport } from './routes/reporting/cashflow'
import { Route as PayoutsPayoutIdRouteImport } from './routes/payouts/$payoutId'
import { Route as PayoutRequestsIdRouteImport } from './routes/payout-requests/$id'
import { Route as PayoutReportDownloadsIdRouteImport } from './routes/payout-report-downloads/$id'
import { Route as OrganizationsEditRouteImport } from './routes/organizations/edit'
import { Route as OppsTemplatesRouteImport } from './routes/opps/templates'
import { Route as OppsNewRouteImport } from './routes/opps/new'
import { Route as InvoiceDownloadsIdRouteImport } from './routes/invoice-downloads/$id'
import { Route as InvitationsNewRouteImport } from './routes/invitations/new'
import { Route as InvitationTokenRouteImport } from './routes/invitation.$token'
import { Route as IntegrationsSkimmerRouteImport } from './routes/integrations/skimmer'
import { Route as IntegrationsHousecallProRouteImport } from './routes/integrations/housecall-pro'
import { Route as IntegrationsColdstandardRouteImport } from './routes/integrations/coldstandard'
import { Route as FundingTransactionsRouteImport } from './routes/funding/transactions'
import { Route as FundingLinkAccountRouteImport } from './routes/funding/link-account'
import { Route as CashflowReportDownloadsIdRouteImport } from './routes/cashflow-report-downloads/$id'
import { Route as CallbackPlaidRouteImport } from './routes/callback/plaid'
import { Route as CallbackAstraRouteImport } from './routes/callback/astra'
import { Route as SettingsTagsIndexRouteImport } from './routes/settings/tags/index'
import { Route as SettingsRolesIndexRouteImport } from './routes/settings/roles/index'
import { Route as SettingsPayoutPoliciesIndexRouteImport } from './routes/settings/payout-policies/index'
import { Route as SettingsNotificationsIndexRouteImport } from './routes/settings/notifications/index'
import { Route as ReportingUnpaidCompletedWorkIndexRouteImport } from './routes/reporting/unpaid-completed-work/index'
import { Route as ProfileNotificationsIndexRouteImport } from './routes/profile/notifications/index'
import { Route as OppsOppIdIndexRouteImport } from './routes/opps/$oppId/index'
import { Route as FundingReceivablesIndexRouteImport } from './routes/funding/receivables.index'
import { Route as StaffIdEditRouteImport } from './routes/staff/$id/edit'
import { Route as SettingsPayoutPoliciesNewRouteImport } from './routes/settings/payout-policies/new'
import { Route as SettingsPayoutPoliciesIdRouteImport } from './routes/settings/payout-policies/$id'
import { Route as RosterOrganizationsIdRouteImport } from './routes/roster/organizations/$id'
import { Route as RosterIdEditRouteImport } from './routes/roster/$id/edit'
import { Route as PayoutsCategoriesCategoryRouteImport } from './routes/payouts/categories/$category'
import { Route as PayoutRequestsDirectIdRouteImport } from './routes/payout-requests/direct/$id'
import { Route as PayoutRequestsCategoriesCategoryRouteImport } from './routes/payout-requests/categories/$category'
import { Route as OppsCategoriesCategoryRouteImport } from './routes/opps/categories/$category'
import { Route as FundingReceivablesPayoutIdRouteImport } from './routes/funding/receivables.$payoutId'
import { Route as FundingAccountsAccountIdRouteImport } from './routes/funding/accounts.$accountId'
import { Route as SettingsRolesIdIndexRouteImport } from './routes/settings/roles/$id/index'
import { Route as PayoutRequestsReimbursementIdIndexRouteImport } from './routes/payout-requests/reimbursement/$id/index'
import { Route as PayoutRequestsFsmIdIndexRouteImport } from './routes/payout-requests/fsm/$id/index'
import { Route as OppsOppIdEditIndexRouteImport } from './routes/opps/$oppId/edit/index'
import { Route as OpportunityClaimsClaimIdTimelineIndexRouteImport } from './routes/opportunity-claims/$claimId/timeline/index'
import { Route as SettingsRolesIdEditRouteImport } from './routes/settings/roles/$id/edit'
import { Route as OppsOppIdEditSuccessRouteImport } from './routes/opps/$oppId/edit/success'
import { Route as OppsOppIdEditSignupRouteImport } from './routes/opps/$oppId/edit/signup'
import { Route as OppsOppIdEditSetRatesRouteImport } from './routes/opps/$oppId/edit/set-rates'
import { Route as OppsOppIdEditProofOfWorkRouteImport } from './routes/opps/$oppId/edit/proof-of-work'
import { Route as OppsOppIdEditParticipationRouteImport } from './routes/opps/$oppId/edit/participation'
import { Route as OppsOppIdEditInviteRouteImport } from './routes/opps/$oppId/edit/invite'
import { Route as OppsOppIdEditDetailRouteImport } from './routes/opps/$oppId/edit/detail'

const TermsAcceptanceRoute = TermsAcceptanceRouteImport.update({
  id: '/terms-acceptance',
  path: '/terms-acceptance',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsRoute = ReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRequestsRoute = JoinRequestsRouteImport.update({
  id: '/join-requests',
  path: '/join-requests',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const FundingRoute = FundingRouteImport.update({
  id: '/funding',
  path: '/funding',
  getParentRoute: () => rootRouteImport,
} as any)
const DevToolsRoute = DevToolsRouteImport.update({
  id: '/dev-tools',
  path: '/dev-tools',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchProcessesRoute = BatchProcessesRouteImport.update({
  id: '/batch-processes',
  path: '/batch-processes',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffIndexRoute = StaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const RosterIndexRoute = RosterIndexRouteImport.update({
  id: '/roster/',
  path: '/roster/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingIndexRoute = ReportingIndexRouteImport.update({
  id: '/reporting/',
  path: '/reporting/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutRequestsIndexRoute = PayoutRequestsIndexRouteImport.update({
  id: '/payout-requests/',
  path: '/payout-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const OppsIndexRoute = OppsIndexRouteImport.update({
  id: '/opps/',
  path: '/opps/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsIndexRoute = InvitationsIndexRouteImport.update({
  id: '/invitations/',
  path: '/invitations/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const FundingIndexRoute = FundingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FundingRoute,
} as any)
const UnpaidCompletedWorkReportDownloadsIdRoute =
  UnpaidCompletedWorkReportDownloadsIdRouteImport.update({
    id: '/unpaid-completed-work-report-downloads/$id',
    path: '/unpaid-completed-work-report-downloads/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemOrglessAccountsRoute = SystemOrglessAccountsRouteImport.update({
  id: '/system/orgless-accounts',
  path: '/system/orgless-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemClassifyDomainRoute = SystemClassifyDomainRouteImport.update({
  id: '/system/classify-domain',
  path: '/system/classify-domain',
  getParentRoute: () => rootRouteImport,
} as any)
const RosterAddRoute = RosterAddRouteImport.update({
  id: '/roster/add',
  path: '/roster/add',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingPayoutsRoute = ReportingPayoutsRouteImport.update({
  id: '/reporting/payouts',
  path: '/reporting/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingCashflowRoute = ReportingCashflowRouteImport.update({
  id: '/reporting/cashflow',
  path: '/reporting/cashflow',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutsPayoutIdRoute = PayoutsPayoutIdRouteImport.update({
  id: '/payouts/$payoutId',
  path: '/payouts/$payoutId',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutRequestsIdRoute = PayoutRequestsIdRouteImport.update({
  id: '/payout-requests/$id',
  path: '/payout-requests/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutReportDownloadsIdRoute = PayoutReportDownloadsIdRouteImport.update({
  id: '/payout-report-downloads/$id',
  path: '/payout-report-downloads/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsEditRoute = OrganizationsEditRouteImport.update({
  id: '/organizations/edit',
  path: '/organizations/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const OppsTemplatesRoute = OppsTemplatesRouteImport.update({
  id: '/opps/templates',
  path: '/opps/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const OppsNewRoute = OppsNewRouteImport.update({
  id: '/opps/new',
  path: '/opps/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoiceDownloadsIdRoute = InvoiceDownloadsIdRouteImport.update({
  id: '/invoice-downloads/$id',
  path: '/invoice-downloads/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsNewRoute = InvitationsNewRouteImport.update({
  id: '/invitations/new',
  path: '/invitations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationTokenRoute = InvitationTokenRouteImport.update({
  id: '/invitation/$token',
  path: '/invitation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsSkimmerRoute = IntegrationsSkimmerRouteImport.update({
  id: '/integrations/skimmer',
  path: '/integrations/skimmer',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsHousecallProRoute =
  IntegrationsHousecallProRouteImport.update({
    id: '/integrations/housecall-pro',
    path: '/integrations/housecall-pro',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsColdstandardRoute =
  IntegrationsColdstandardRouteImport.update({
    id: '/integrations/coldstandard',
    path: '/integrations/coldstandard',
    getParentRoute: () => rootRouteImport,
  } as any)
const FundingTransactionsRoute = FundingTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => FundingRoute,
} as any)
const FundingLinkAccountRoute = FundingLinkAccountRouteImport.update({
  id: '/link-account',
  path: '/link-account',
  getParentRoute: () => FundingRoute,
} as any)
const CashflowReportDownloadsIdRoute =
  CashflowReportDownloadsIdRouteImport.update({
    id: '/cashflow-report-downloads/$id',
    path: '/cashflow-report-downloads/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const CallbackPlaidRoute = CallbackPlaidRouteImport.update({
  id: '/callback/plaid',
  path: '/callback/plaid',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackAstraRoute = CallbackAstraRouteImport.update({
  id: '/callback/astra',
  path: '/callback/astra',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTagsIndexRoute = SettingsTagsIndexRouteImport.update({
  id: '/settings/tags/',
  path: '/settings/tags/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRolesIndexRoute = SettingsRolesIndexRouteImport.update({
  id: '/settings/roles/',
  path: '/settings/roles/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPayoutPoliciesIndexRoute =
  SettingsPayoutPoliciesIndexRouteImport.update({
    id: '/settings/payout-policies/',
    path: '/settings/payout-policies/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsNotificationsIndexRoute =
  SettingsNotificationsIndexRouteImport.update({
    id: '/settings/notifications/',
    path: '/settings/notifications/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportingUnpaidCompletedWorkIndexRoute =
  ReportingUnpaidCompletedWorkIndexRouteImport.update({
    id: '/reporting/unpaid-completed-work/',
    path: '/reporting/unpaid-completed-work/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfileNotificationsIndexRoute =
  ProfileNotificationsIndexRouteImport.update({
    id: '/profile/notifications/',
    path: '/profile/notifications/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OppsOppIdIndexRoute = OppsOppIdIndexRouteImport.update({
  id: '/opps/$oppId/',
  path: '/opps/$oppId/',
  getParentRoute: () => rootRouteImport,
} as any)
const FundingReceivablesIndexRoute = FundingReceivablesIndexRouteImport.update({
  id: '/receivables/',
  path: '/receivables/',
  getParentRoute: () => FundingRoute,
} as any)
const StaffIdEditRoute = StaffIdEditRouteImport.update({
  id: '/staff/$id/edit',
  path: '/staff/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPayoutPoliciesNewRoute =
  SettingsPayoutPoliciesNewRouteImport.update({
    id: '/settings/payout-policies/new',
    path: '/settings/payout-policies/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsPayoutPoliciesIdRoute =
  SettingsPayoutPoliciesIdRouteImport.update({
    id: '/settings/payout-policies/$id',
    path: '/settings/payout-policies/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const RosterOrganizationsIdRoute = RosterOrganizationsIdRouteImport.update({
  id: '/roster/organizations/$id',
  path: '/roster/organizations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RosterIdEditRoute = RosterIdEditRouteImport.update({
  id: '/roster/$id/edit',
  path: '/roster/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutsCategoriesCategoryRoute =
  PayoutsCategoriesCategoryRouteImport.update({
    id: '/payouts/categories/$category',
    path: '/payouts/categories/$category',
    getParentRoute: () => rootRouteImport,
  } as any)
const PayoutRequestsDirectIdRoute = PayoutRequestsDirectIdRouteImport.update({
  id: '/payout-requests/direct/$id',
  path: '/payout-requests/direct/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutRequestsCategoriesCategoryRoute =
  PayoutRequestsCategoriesCategoryRouteImport.update({
    id: '/payout-requests/categories/$category',
    path: '/payout-requests/categories/$category',
    getParentRoute: () => rootRouteImport,
  } as any)
const OppsCategoriesCategoryRoute = OppsCategoriesCategoryRouteImport.update({
  id: '/opps/categories/$category',
  path: '/opps/categories/$category',
  getParentRoute: () => rootRouteImport,
} as any)
const FundingReceivablesPayoutIdRoute =
  FundingReceivablesPayoutIdRouteImport.update({
    id: '/receivables/$payoutId',
    path: '/receivables/$payoutId',
    getParentRoute: () => FundingRoute,
  } as any)
const FundingAccountsAccountIdRoute =
  FundingAccountsAccountIdRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => FundingRoute,
  } as any)
const SettingsRolesIdIndexRoute = SettingsRolesIdIndexRouteImport.update({
  id: '/settings/roles/$id/',
  path: '/settings/roles/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutRequestsReimbursementIdIndexRoute =
  PayoutRequestsReimbursementIdIndexRouteImport.update({
    id: '/payout-requests/reimbursement/$id/',
    path: '/payout-requests/reimbursement/$id/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PayoutRequestsFsmIdIndexRoute =
  PayoutRequestsFsmIdIndexRouteImport.update({
    id: '/payout-requests/fsm/$id/',
    path: '/payout-requests/fsm/$id/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OppsOppIdEditIndexRoute = OppsOppIdEditIndexRouteImport.update({
  id: '/opps/$oppId/edit/',
  path: '/opps/$oppId/edit/',
  getParentRoute: () => rootRouteImport,
} as any)
const OpportunityClaimsClaimIdTimelineIndexRoute =
  OpportunityClaimsClaimIdTimelineIndexRouteImport.update({
    id: '/opportunity-claims/$claimId/timeline/',
    path: '/opportunity-claims/$claimId/timeline/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsRolesIdEditRoute = SettingsRolesIdEditRouteImport.update({
  id: '/settings/roles/$id/edit',
  path: '/settings/roles/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const OppsOppIdEditSuccessRoute = OppsOppIdEditSuccessRouteImport.update({
  id: '/opps/$oppId/edit/success',
  path: '/opps/$oppId/edit/success',
  getParentRoute: () => rootRouteImport,
} as any)
const OppsOppIdEditSignupRoute = OppsOppIdEditSignupRouteImport.update({
  id: '/opps/$oppId/edit/signup',
  path: '/opps/$oppId/edit/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const OppsOppIdEditSetRatesRoute = OppsOppIdEditSetRatesRouteImport.update({
  id: '/opps/$oppId/edit/set-rates',
  path: '/opps/$oppId/edit/set-rates',
  getParentRoute: () => rootRouteImport,
} as any)
const OppsOppIdEditProofOfWorkRoute =
  OppsOppIdEditProofOfWorkRouteImport.update({
    id: '/opps/$oppId/edit/proof-of-work',
    path: '/opps/$oppId/edit/proof-of-work',
    getParentRoute: () => rootRouteImport,
  } as any)
const OppsOppIdEditParticipationRoute =
  OppsOppIdEditParticipationRouteImport.update({
    id: '/opps/$oppId/edit/participation',
    path: '/opps/$oppId/edit/participation',
    getParentRoute: () => rootRouteImport,
  } as any)
const OppsOppIdEditInviteRoute = OppsOppIdEditInviteRouteImport.update({
  id: '/opps/$oppId/edit/invite',
  path: '/opps/$oppId/edit/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const OppsOppIdEditDetailRoute = OppsOppIdEditDetailRouteImport.update({
  id: '/opps/$oppId/edit/detail',
  path: '/opps/$oppId/edit/detail',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/batch-processes': typeof BatchProcessesRoute
  '/dashboard': typeof DashboardRoute
  '/dev-tools': typeof DevToolsRoute
  '/funding': typeof FundingRouteWithChildren
  '/home': typeof HomeRoute
  '/join-requests': typeof JoinRequestsRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/referrals': typeof ReferralsRoute
  '/terms-acceptance': typeof TermsAcceptanceRoute
  '/callback/astra': typeof CallbackAstraRoute
  '/callback/plaid': typeof CallbackPlaidRoute
  '/cashflow-report-downloads/$id': typeof CashflowReportDownloadsIdRoute
  '/funding/link-account': typeof FundingLinkAccountRoute
  '/funding/transactions': typeof FundingTransactionsRoute
  '/integrations/coldstandard': typeof IntegrationsColdstandardRoute
  '/integrations/housecall-pro': typeof IntegrationsHousecallProRoute
  '/integrations/skimmer': typeof IntegrationsSkimmerRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/invitations/new': typeof InvitationsNewRoute
  '/invoice-downloads/$id': typeof InvoiceDownloadsIdRoute
  '/opps/new': typeof OppsNewRoute
  '/opps/templates': typeof OppsTemplatesRoute
  '/organizations/edit': typeof OrganizationsEditRoute
  '/payout-report-downloads/$id': typeof PayoutReportDownloadsIdRoute
  '/payout-requests/$id': typeof PayoutRequestsIdRoute
  '/payouts/$payoutId': typeof PayoutsPayoutIdRoute
  '/reporting/cashflow': typeof ReportingCashflowRoute
  '/reporting/payouts': typeof ReportingPayoutsRoute
  '/roster/add': typeof RosterAddRoute
  '/system/classify-domain': typeof SystemClassifyDomainRoute
  '/system/orgless-accounts': typeof SystemOrglessAccountsRoute
  '/unpaid-completed-work-report-downloads/$id': typeof UnpaidCompletedWorkReportDownloadsIdRoute
  '/funding/': typeof FundingIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/invitations': typeof InvitationsIndexRoute
  '/opps': typeof OppsIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/payout-requests': typeof PayoutRequestsIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/reporting': typeof ReportingIndexRoute
  '/roster': typeof RosterIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/staff': typeof StaffIndexRoute
  '/funding/accounts/$accountId': typeof FundingAccountsAccountIdRoute
  '/funding/receivables/$payoutId': typeof FundingReceivablesPayoutIdRoute
  '/opps/categories/$category': typeof OppsCategoriesCategoryRoute
  '/payout-requests/categories/$category': typeof PayoutRequestsCategoriesCategoryRoute
  '/payout-requests/direct/$id': typeof PayoutRequestsDirectIdRoute
  '/payouts/categories/$category': typeof PayoutsCategoriesCategoryRoute
  '/roster/$id/edit': typeof RosterIdEditRoute
  '/roster/organizations/$id': typeof RosterOrganizationsIdRoute
  '/settings/payout-policies/$id': typeof SettingsPayoutPoliciesIdRoute
  '/settings/payout-policies/new': typeof SettingsPayoutPoliciesNewRoute
  '/staff/$id/edit': typeof StaffIdEditRoute
  '/funding/receivables': typeof FundingReceivablesIndexRoute
  '/opps/$oppId': typeof OppsOppIdIndexRoute
  '/profile/notifications': typeof ProfileNotificationsIndexRoute
  '/reporting/unpaid-completed-work': typeof ReportingUnpaidCompletedWorkIndexRoute
  '/settings/notifications': typeof SettingsNotificationsIndexRoute
  '/settings/payout-policies': typeof SettingsPayoutPoliciesIndexRoute
  '/settings/roles': typeof SettingsRolesIndexRoute
  '/settings/tags': typeof SettingsTagsIndexRoute
  '/opps/$oppId/edit/detail': typeof OppsOppIdEditDetailRoute
  '/opps/$oppId/edit/invite': typeof OppsOppIdEditInviteRoute
  '/opps/$oppId/edit/participation': typeof OppsOppIdEditParticipationRoute
  '/opps/$oppId/edit/proof-of-work': typeof OppsOppIdEditProofOfWorkRoute
  '/opps/$oppId/edit/set-rates': typeof OppsOppIdEditSetRatesRoute
  '/opps/$oppId/edit/signup': typeof OppsOppIdEditSignupRoute
  '/opps/$oppId/edit/success': typeof OppsOppIdEditSuccessRoute
  '/settings/roles/$id/edit': typeof SettingsRolesIdEditRoute
  '/opportunity-claims/$claimId/timeline': typeof OpportunityClaimsClaimIdTimelineIndexRoute
  '/opps/$oppId/edit': typeof OppsOppIdEditIndexRoute
  '/payout-requests/fsm/$id': typeof PayoutRequestsFsmIdIndexRoute
  '/payout-requests/reimbursement/$id': typeof PayoutRequestsReimbursementIdIndexRoute
  '/settings/roles/$id': typeof SettingsRolesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/batch-processes': typeof BatchProcessesRoute
  '/dashboard': typeof DashboardRoute
  '/dev-tools': typeof DevToolsRoute
  '/home': typeof HomeRoute
  '/join-requests': typeof JoinRequestsRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/referrals': typeof ReferralsRoute
  '/terms-acceptance': typeof TermsAcceptanceRoute
  '/callback/astra': typeof CallbackAstraRoute
  '/callback/plaid': typeof CallbackPlaidRoute
  '/cashflow-report-downloads/$id': typeof CashflowReportDownloadsIdRoute
  '/funding/link-account': typeof FundingLinkAccountRoute
  '/funding/transactions': typeof FundingTransactionsRoute
  '/integrations/coldstandard': typeof IntegrationsColdstandardRoute
  '/integrations/housecall-pro': typeof IntegrationsHousecallProRoute
  '/integrations/skimmer': typeof IntegrationsSkimmerRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/invitations/new': typeof InvitationsNewRoute
  '/invoice-downloads/$id': typeof InvoiceDownloadsIdRoute
  '/opps/new': typeof OppsNewRoute
  '/opps/templates': typeof OppsTemplatesRoute
  '/organizations/edit': typeof OrganizationsEditRoute
  '/payout-report-downloads/$id': typeof PayoutReportDownloadsIdRoute
  '/payout-requests/$id': typeof PayoutRequestsIdRoute
  '/payouts/$payoutId': typeof PayoutsPayoutIdRoute
  '/reporting/cashflow': typeof ReportingCashflowRoute
  '/reporting/payouts': typeof ReportingPayoutsRoute
  '/roster/add': typeof RosterAddRoute
  '/system/classify-domain': typeof SystemClassifyDomainRoute
  '/system/orgless-accounts': typeof SystemOrglessAccountsRoute
  '/unpaid-completed-work-report-downloads/$id': typeof UnpaidCompletedWorkReportDownloadsIdRoute
  '/funding': typeof FundingIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/invitations': typeof InvitationsIndexRoute
  '/opps': typeof OppsIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/payout-requests': typeof PayoutRequestsIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/reporting': typeof ReportingIndexRoute
  '/roster': typeof RosterIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/staff': typeof StaffIndexRoute
  '/funding/accounts/$accountId': typeof FundingAccountsAccountIdRoute
  '/funding/receivables/$payoutId': typeof FundingReceivablesPayoutIdRoute
  '/opps/categories/$category': typeof OppsCategoriesCategoryRoute
  '/payout-requests/categories/$category': typeof PayoutRequestsCategoriesCategoryRoute
  '/payout-requests/direct/$id': typeof PayoutRequestsDirectIdRoute
  '/payouts/categories/$category': typeof PayoutsCategoriesCategoryRoute
  '/roster/$id/edit': typeof RosterIdEditRoute
  '/roster/organizations/$id': typeof RosterOrganizationsIdRoute
  '/settings/payout-policies/$id': typeof SettingsPayoutPoliciesIdRoute
  '/settings/payout-policies/new': typeof SettingsPayoutPoliciesNewRoute
  '/staff/$id/edit': typeof StaffIdEditRoute
  '/funding/receivables': typeof FundingReceivablesIndexRoute
  '/opps/$oppId': typeof OppsOppIdIndexRoute
  '/profile/notifications': typeof ProfileNotificationsIndexRoute
  '/reporting/unpaid-completed-work': typeof ReportingUnpaidCompletedWorkIndexRoute
  '/settings/notifications': typeof SettingsNotificationsIndexRoute
  '/settings/payout-policies': typeof SettingsPayoutPoliciesIndexRoute
  '/settings/roles': typeof SettingsRolesIndexRoute
  '/settings/tags': typeof SettingsTagsIndexRoute
  '/opps/$oppId/edit/detail': typeof OppsOppIdEditDetailRoute
  '/opps/$oppId/edit/invite': typeof OppsOppIdEditInviteRoute
  '/opps/$oppId/edit/participation': typeof OppsOppIdEditParticipationRoute
  '/opps/$oppId/edit/proof-of-work': typeof OppsOppIdEditProofOfWorkRoute
  '/opps/$oppId/edit/set-rates': typeof OppsOppIdEditSetRatesRoute
  '/opps/$oppId/edit/signup': typeof OppsOppIdEditSignupRoute
  '/opps/$oppId/edit/success': typeof OppsOppIdEditSuccessRoute
  '/settings/roles/$id/edit': typeof SettingsRolesIdEditRoute
  '/opportunity-claims/$claimId/timeline': typeof OpportunityClaimsClaimIdTimelineIndexRoute
  '/opps/$oppId/edit': typeof OppsOppIdEditIndexRoute
  '/payout-requests/fsm/$id': typeof PayoutRequestsFsmIdIndexRoute
  '/payout-requests/reimbursement/$id': typeof PayoutRequestsReimbursementIdIndexRoute
  '/settings/roles/$id': typeof SettingsRolesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/batch-processes': typeof BatchProcessesRoute
  '/dashboard': typeof DashboardRoute
  '/dev-tools': typeof DevToolsRoute
  '/funding': typeof FundingRouteWithChildren
  '/home': typeof HomeRoute
  '/join-requests': typeof JoinRequestsRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/referrals': typeof ReferralsRoute
  '/terms-acceptance': typeof TermsAcceptanceRoute
  '/callback/astra': typeof CallbackAstraRoute
  '/callback/plaid': typeof CallbackPlaidRoute
  '/cashflow-report-downloads/$id': typeof CashflowReportDownloadsIdRoute
  '/funding/link-account': typeof FundingLinkAccountRoute
  '/funding/transactions': typeof FundingTransactionsRoute
  '/integrations/coldstandard': typeof IntegrationsColdstandardRoute
  '/integrations/housecall-pro': typeof IntegrationsHousecallProRoute
  '/integrations/skimmer': typeof IntegrationsSkimmerRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/invitations/new': typeof InvitationsNewRoute
  '/invoice-downloads/$id': typeof InvoiceDownloadsIdRoute
  '/opps/new': typeof OppsNewRoute
  '/opps/templates': typeof OppsTemplatesRoute
  '/organizations/edit': typeof OrganizationsEditRoute
  '/payout-report-downloads/$id': typeof PayoutReportDownloadsIdRoute
  '/payout-requests/$id': typeof PayoutRequestsIdRoute
  '/payouts/$payoutId': typeof PayoutsPayoutIdRoute
  '/reporting/cashflow': typeof ReportingCashflowRoute
  '/reporting/payouts': typeof ReportingPayoutsRoute
  '/roster/add': typeof RosterAddRoute
  '/system/classify-domain': typeof SystemClassifyDomainRoute
  '/system/orgless-accounts': typeof SystemOrglessAccountsRoute
  '/unpaid-completed-work-report-downloads/$id': typeof UnpaidCompletedWorkReportDownloadsIdRoute
  '/funding/': typeof FundingIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/invitations/': typeof InvitationsIndexRoute
  '/opps/': typeof OppsIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/payout-requests/': typeof PayoutRequestsIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/reporting/': typeof ReportingIndexRoute
  '/roster/': typeof RosterIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/staff/': typeof StaffIndexRoute
  '/funding/accounts/$accountId': typeof FundingAccountsAccountIdRoute
  '/funding/receivables/$payoutId': typeof FundingReceivablesPayoutIdRoute
  '/opps/categories/$category': typeof OppsCategoriesCategoryRoute
  '/payout-requests/categories/$category': typeof PayoutRequestsCategoriesCategoryRoute
  '/payout-requests/direct/$id': typeof PayoutRequestsDirectIdRoute
  '/payouts/categories/$category': typeof PayoutsCategoriesCategoryRoute
  '/roster/$id/edit': typeof RosterIdEditRoute
  '/roster/organizations/$id': typeof RosterOrganizationsIdRoute
  '/settings/payout-policies/$id': typeof SettingsPayoutPoliciesIdRoute
  '/settings/payout-policies/new': typeof SettingsPayoutPoliciesNewRoute
  '/staff/$id/edit': typeof StaffIdEditRoute
  '/funding/receivables/': typeof FundingReceivablesIndexRoute
  '/opps/$oppId/': typeof OppsOppIdIndexRoute
  '/profile/notifications/': typeof ProfileNotificationsIndexRoute
  '/reporting/unpaid-completed-work/': typeof ReportingUnpaidCompletedWorkIndexRoute
  '/settings/notifications/': typeof SettingsNotificationsIndexRoute
  '/settings/payout-policies/': typeof SettingsPayoutPoliciesIndexRoute
  '/settings/roles/': typeof SettingsRolesIndexRoute
  '/settings/tags/': typeof SettingsTagsIndexRoute
  '/opps/$oppId/edit/detail': typeof OppsOppIdEditDetailRoute
  '/opps/$oppId/edit/invite': typeof OppsOppIdEditInviteRoute
  '/opps/$oppId/edit/participation': typeof OppsOppIdEditParticipationRoute
  '/opps/$oppId/edit/proof-of-work': typeof OppsOppIdEditProofOfWorkRoute
  '/opps/$oppId/edit/set-rates': typeof OppsOppIdEditSetRatesRoute
  '/opps/$oppId/edit/signup': typeof OppsOppIdEditSignupRoute
  '/opps/$oppId/edit/success': typeof OppsOppIdEditSuccessRoute
  '/settings/roles/$id/edit': typeof SettingsRolesIdEditRoute
  '/opportunity-claims/$claimId/timeline/': typeof OpportunityClaimsClaimIdTimelineIndexRoute
  '/opps/$oppId/edit/': typeof OppsOppIdEditIndexRoute
  '/payout-requests/fsm/$id/': typeof PayoutRequestsFsmIdIndexRoute
  '/payout-requests/reimbursement/$id/': typeof PayoutRequestsReimbursementIdIndexRoute
  '/settings/roles/$id/': typeof SettingsRolesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/batch-processes'
    | '/dashboard'
    | '/dev-tools'
    | '/funding'
    | '/home'
    | '/join-requests'
    | '/notifications'
    | '/onboarding'
    | '/referrals'
    | '/terms-acceptance'
    | '/callback/astra'
    | '/callback/plaid'
    | '/cashflow-report-downloads/$id'
    | '/funding/link-account'
    | '/funding/transactions'
    | '/integrations/coldstandard'
    | '/integrations/housecall-pro'
    | '/integrations/skimmer'
    | '/invitation/$token'
    | '/invitations/new'
    | '/invoice-downloads/$id'
    | '/opps/new'
    | '/opps/templates'
    | '/organizations/edit'
    | '/payout-report-downloads/$id'
    | '/payout-requests/$id'
    | '/payouts/$payoutId'
    | '/reporting/cashflow'
    | '/reporting/payouts'
    | '/roster/add'
    | '/system/classify-domain'
    | '/system/orgless-accounts'
    | '/unpaid-completed-work-report-downloads/$id'
    | '/funding/'
    | '/integrations'
    | '/invitations'
    | '/opps'
    | '/organizations'
    | '/payout-requests'
    | '/profile'
    | '/reporting'
    | '/roster'
    | '/settings'
    | '/staff'
    | '/funding/accounts/$accountId'
    | '/funding/receivables/$payoutId'
    | '/opps/categories/$category'
    | '/payout-requests/categories/$category'
    | '/payout-requests/direct/$id'
    | '/payouts/categories/$category'
    | '/roster/$id/edit'
    | '/roster/organizations/$id'
    | '/settings/payout-policies/$id'
    | '/settings/payout-policies/new'
    | '/staff/$id/edit'
    | '/funding/receivables'
    | '/opps/$oppId'
    | '/profile/notifications'
    | '/reporting/unpaid-completed-work'
    | '/settings/notifications'
    | '/settings/payout-policies'
    | '/settings/roles'
    | '/settings/tags'
    | '/opps/$oppId/edit/detail'
    | '/opps/$oppId/edit/invite'
    | '/opps/$oppId/edit/participation'
    | '/opps/$oppId/edit/proof-of-work'
    | '/opps/$oppId/edit/set-rates'
    | '/opps/$oppId/edit/signup'
    | '/opps/$oppId/edit/success'
    | '/settings/roles/$id/edit'
    | '/opportunity-claims/$claimId/timeline'
    | '/opps/$oppId/edit'
    | '/payout-requests/fsm/$id'
    | '/payout-requests/reimbursement/$id'
    | '/settings/roles/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/batch-processes'
    | '/dashboard'
    | '/dev-tools'
    | '/home'
    | '/join-requests'
    | '/notifications'
    | '/onboarding'
    | '/referrals'
    | '/terms-acceptance'
    | '/callback/astra'
    | '/callback/plaid'
    | '/cashflow-report-downloads/$id'
    | '/funding/link-account'
    | '/funding/transactions'
    | '/integrations/coldstandard'
    | '/integrations/housecall-pro'
    | '/integrations/skimmer'
    | '/invitation/$token'
    | '/invitations/new'
    | '/invoice-downloads/$id'
    | '/opps/new'
    | '/opps/templates'
    | '/organizations/edit'
    | '/payout-report-downloads/$id'
    | '/payout-requests/$id'
    | '/payouts/$payoutId'
    | '/reporting/cashflow'
    | '/reporting/payouts'
    | '/roster/add'
    | '/system/classify-domain'
    | '/system/orgless-accounts'
    | '/unpaid-completed-work-report-downloads/$id'
    | '/funding'
    | '/integrations'
    | '/invitations'
    | '/opps'
    | '/organizations'
    | '/payout-requests'
    | '/profile'
    | '/reporting'
    | '/roster'
    | '/settings'
    | '/staff'
    | '/funding/accounts/$accountId'
    | '/funding/receivables/$payoutId'
    | '/opps/categories/$category'
    | '/payout-requests/categories/$category'
    | '/payout-requests/direct/$id'
    | '/payouts/categories/$category'
    | '/roster/$id/edit'
    | '/roster/organizations/$id'
    | '/settings/payout-policies/$id'
    | '/settings/payout-policies/new'
    | '/staff/$id/edit'
    | '/funding/receivables'
    | '/opps/$oppId'
    | '/profile/notifications'
    | '/reporting/unpaid-completed-work'
    | '/settings/notifications'
    | '/settings/payout-policies'
    | '/settings/roles'
    | '/settings/tags'
    | '/opps/$oppId/edit/detail'
    | '/opps/$oppId/edit/invite'
    | '/opps/$oppId/edit/participation'
    | '/opps/$oppId/edit/proof-of-work'
    | '/opps/$oppId/edit/set-rates'
    | '/opps/$oppId/edit/signup'
    | '/opps/$oppId/edit/success'
    | '/settings/roles/$id/edit'
    | '/opportunity-claims/$claimId/timeline'
    | '/opps/$oppId/edit'
    | '/payout-requests/fsm/$id'
    | '/payout-requests/reimbursement/$id'
    | '/settings/roles/$id'
  id:
    | '__root__'
    | '/'
    | '/batch-processes'
    | '/dashboard'
    | '/dev-tools'
    | '/funding'
    | '/home'
    | '/join-requests'
    | '/notifications'
    | '/onboarding'
    | '/referrals'
    | '/terms-acceptance'
    | '/callback/astra'
    | '/callback/plaid'
    | '/cashflow-report-downloads/$id'
    | '/funding/link-account'
    | '/funding/transactions'
    | '/integrations/coldstandard'
    | '/integrations/housecall-pro'
    | '/integrations/skimmer'
    | '/invitation/$token'
    | '/invitations/new'
    | '/invoice-downloads/$id'
    | '/opps/new'
    | '/opps/templates'
    | '/organizations/edit'
    | '/payout-report-downloads/$id'
    | '/payout-requests/$id'
    | '/payouts/$payoutId'
    | '/reporting/cashflow'
    | '/reporting/payouts'
    | '/roster/add'
    | '/system/classify-domain'
    | '/system/orgless-accounts'
    | '/unpaid-completed-work-report-downloads/$id'
    | '/funding/'
    | '/integrations/'
    | '/invitations/'
    | '/opps/'
    | '/organizations/'
    | '/payout-requests/'
    | '/profile/'
    | '/reporting/'
    | '/roster/'
    | '/settings/'
    | '/staff/'
    | '/funding/accounts/$accountId'
    | '/funding/receivables/$payoutId'
    | '/opps/categories/$category'
    | '/payout-requests/categories/$category'
    | '/payout-requests/direct/$id'
    | '/payouts/categories/$category'
    | '/roster/$id/edit'
    | '/roster/organizations/$id'
    | '/settings/payout-policies/$id'
    | '/settings/payout-policies/new'
    | '/staff/$id/edit'
    | '/funding/receivables/'
    | '/opps/$oppId/'
    | '/profile/notifications/'
    | '/reporting/unpaid-completed-work/'
    | '/settings/notifications/'
    | '/settings/payout-policies/'
    | '/settings/roles/'
    | '/settings/tags/'
    | '/opps/$oppId/edit/detail'
    | '/opps/$oppId/edit/invite'
    | '/opps/$oppId/edit/participation'
    | '/opps/$oppId/edit/proof-of-work'
    | '/opps/$oppId/edit/set-rates'
    | '/opps/$oppId/edit/signup'
    | '/opps/$oppId/edit/success'
    | '/settings/roles/$id/edit'
    | '/opportunity-claims/$claimId/timeline/'
    | '/opps/$oppId/edit/'
    | '/payout-requests/fsm/$id/'
    | '/payout-requests/reimbursement/$id/'
    | '/settings/roles/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BatchProcessesRoute: typeof BatchProcessesRoute
  DashboardRoute: typeof DashboardRoute
  DevToolsRoute: typeof DevToolsRoute
  FundingRoute: typeof FundingRouteWithChildren
  HomeRoute: typeof HomeRoute
  JoinRequestsRoute: typeof JoinRequestsRoute
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  ReferralsRoute: typeof ReferralsRoute
  TermsAcceptanceRoute: typeof TermsAcceptanceRoute
  CallbackAstraRoute: typeof CallbackAstraRoute
  CallbackPlaidRoute: typeof CallbackPlaidRoute
  CashflowReportDownloadsIdRoute: typeof CashflowReportDownloadsIdRoute
  IntegrationsColdstandardRoute: typeof IntegrationsColdstandardRoute
  IntegrationsHousecallProRoute: typeof IntegrationsHousecallProRoute
  IntegrationsSkimmerRoute: typeof IntegrationsSkimmerRoute
  InvitationTokenRoute: typeof InvitationTokenRoute
  InvitationsNewRoute: typeof InvitationsNewRoute
  InvoiceDownloadsIdRoute: typeof InvoiceDownloadsIdRoute
  OppsNewRoute: typeof OppsNewRoute
  OppsTemplatesRoute: typeof OppsTemplatesRoute
  OrganizationsEditRoute: typeof OrganizationsEditRoute
  PayoutReportDownloadsIdRoute: typeof PayoutReportDownloadsIdRoute
  PayoutRequestsIdRoute: typeof PayoutRequestsIdRoute
  PayoutsPayoutIdRoute: typeof PayoutsPayoutIdRoute
  ReportingCashflowRoute: typeof ReportingCashflowRoute
  ReportingPayoutsRoute: typeof ReportingPayoutsRoute
  RosterAddRoute: typeof RosterAddRoute
  SystemClassifyDomainRoute: typeof SystemClassifyDomainRoute
  SystemOrglessAccountsRoute: typeof SystemOrglessAccountsRoute
  UnpaidCompletedWorkReportDownloadsIdRoute: typeof UnpaidCompletedWorkReportDownloadsIdRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  InvitationsIndexRoute: typeof InvitationsIndexRoute
  OppsIndexRoute: typeof OppsIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  PayoutRequestsIndexRoute: typeof PayoutRequestsIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  ReportingIndexRoute: typeof ReportingIndexRoute
  RosterIndexRoute: typeof RosterIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  StaffIndexRoute: typeof StaffIndexRoute
  OppsCategoriesCategoryRoute: typeof OppsCategoriesCategoryRoute
  PayoutRequestsCategoriesCategoryRoute: typeof PayoutRequestsCategoriesCategoryRoute
  PayoutRequestsDirectIdRoute: typeof PayoutRequestsDirectIdRoute
  PayoutsCategoriesCategoryRoute: typeof PayoutsCategoriesCategoryRoute
  RosterIdEditRoute: typeof RosterIdEditRoute
  RosterOrganizationsIdRoute: typeof RosterOrganizationsIdRoute
  SettingsPayoutPoliciesIdRoute: typeof SettingsPayoutPoliciesIdRoute
  SettingsPayoutPoliciesNewRoute: typeof SettingsPayoutPoliciesNewRoute
  StaffIdEditRoute: typeof StaffIdEditRoute
  OppsOppIdIndexRoute: typeof OppsOppIdIndexRoute
  ProfileNotificationsIndexRoute: typeof ProfileNotificationsIndexRoute
  ReportingUnpaidCompletedWorkIndexRoute: typeof ReportingUnpaidCompletedWorkIndexRoute
  SettingsNotificationsIndexRoute: typeof SettingsNotificationsIndexRoute
  SettingsPayoutPoliciesIndexRoute: typeof SettingsPayoutPoliciesIndexRoute
  SettingsRolesIndexRoute: typeof SettingsRolesIndexRoute
  SettingsTagsIndexRoute: typeof SettingsTagsIndexRoute
  OppsOppIdEditDetailRoute: typeof OppsOppIdEditDetailRoute
  OppsOppIdEditInviteRoute: typeof OppsOppIdEditInviteRoute
  OppsOppIdEditParticipationRoute: typeof OppsOppIdEditParticipationRoute
  OppsOppIdEditProofOfWorkRoute: typeof OppsOppIdEditProofOfWorkRoute
  OppsOppIdEditSetRatesRoute: typeof OppsOppIdEditSetRatesRoute
  OppsOppIdEditSignupRoute: typeof OppsOppIdEditSignupRoute
  OppsOppIdEditSuccessRoute: typeof OppsOppIdEditSuccessRoute
  SettingsRolesIdEditRoute: typeof SettingsRolesIdEditRoute
  OpportunityClaimsClaimIdTimelineIndexRoute: typeof OpportunityClaimsClaimIdTimelineIndexRoute
  OppsOppIdEditIndexRoute: typeof OppsOppIdEditIndexRoute
  PayoutRequestsFsmIdIndexRoute: typeof PayoutRequestsFsmIdIndexRoute
  PayoutRequestsReimbursementIdIndexRoute: typeof PayoutRequestsReimbursementIdIndexRoute
  SettingsRolesIdIndexRoute: typeof SettingsRolesIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-acceptance': {
      id: '/terms-acceptance'
      path: '/terms-acceptance'
      fullPath: '/terms-acceptance'
      preLoaderRoute: typeof TermsAcceptanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals': {
      id: '/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join-requests': {
      id: '/join-requests'
      path: '/join-requests'
      fullPath: '/join-requests'
      preLoaderRoute: typeof JoinRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funding': {
      id: '/funding'
      path: '/funding'
      fullPath: '/funding'
      preLoaderRoute: typeof FundingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev-tools': {
      id: '/dev-tools'
      path: '/dev-tools'
      fullPath: '/dev-tools'
      preLoaderRoute: typeof DevToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batch-processes': {
      id: '/batch-processes'
      path: '/batch-processes'
      fullPath: '/batch-processes'
      preLoaderRoute: typeof BatchProcessesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/': {
      id: '/staff/'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roster/': {
      id: '/roster/'
      path: '/roster'
      fullPath: '/roster'
      preLoaderRoute: typeof RosterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/': {
      id: '/reporting/'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof ReportingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payout-requests/': {
      id: '/payout-requests/'
      path: '/payout-requests'
      fullPath: '/payout-requests'
      preLoaderRoute: typeof PayoutRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/': {
      id: '/opps/'
      path: '/opps'
      fullPath: '/opps'
      preLoaderRoute: typeof OppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/': {
      id: '/invitations/'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof InvitationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funding/': {
      id: '/funding/'
      path: '/'
      fullPath: '/funding/'
      preLoaderRoute: typeof FundingIndexRouteImport
      parentRoute: typeof FundingRoute
    }
    '/unpaid-completed-work-report-downloads/$id': {
      id: '/unpaid-completed-work-report-downloads/$id'
      path: '/unpaid-completed-work-report-downloads/$id'
      fullPath: '/unpaid-completed-work-report-downloads/$id'
      preLoaderRoute: typeof UnpaidCompletedWorkReportDownloadsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/orgless-accounts': {
      id: '/system/orgless-accounts'
      path: '/system/orgless-accounts'
      fullPath: '/system/orgless-accounts'
      preLoaderRoute: typeof SystemOrglessAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/classify-domain': {
      id: '/system/classify-domain'
      path: '/system/classify-domain'
      fullPath: '/system/classify-domain'
      preLoaderRoute: typeof SystemClassifyDomainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roster/add': {
      id: '/roster/add'
      path: '/roster/add'
      fullPath: '/roster/add'
      preLoaderRoute: typeof RosterAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/payouts': {
      id: '/reporting/payouts'
      path: '/reporting/payouts'
      fullPath: '/reporting/payouts'
      preLoaderRoute: typeof ReportingPayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/cashflow': {
      id: '/reporting/cashflow'
      path: '/reporting/cashflow'
      fullPath: '/reporting/cashflow'
      preLoaderRoute: typeof ReportingCashflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payouts/$payoutId': {
      id: '/payouts/$payoutId'
      path: '/payouts/$payoutId'
      fullPath: '/payouts/$payoutId'
      preLoaderRoute: typeof PayoutsPayoutIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payout-requests/$id': {
      id: '/payout-requests/$id'
      path: '/payout-requests/$id'
      fullPath: '/payout-requests/$id'
      preLoaderRoute: typeof PayoutRequestsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payout-report-downloads/$id': {
      id: '/payout-report-downloads/$id'
      path: '/payout-report-downloads/$id'
      fullPath: '/payout-report-downloads/$id'
      preLoaderRoute: typeof PayoutReportDownloadsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/edit': {
      id: '/organizations/edit'
      path: '/organizations/edit'
      fullPath: '/organizations/edit'
      preLoaderRoute: typeof OrganizationsEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/templates': {
      id: '/opps/templates'
      path: '/opps/templates'
      fullPath: '/opps/templates'
      preLoaderRoute: typeof OppsTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/new': {
      id: '/opps/new'
      path: '/opps/new'
      fullPath: '/opps/new'
      preLoaderRoute: typeof OppsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoice-downloads/$id': {
      id: '/invoice-downloads/$id'
      path: '/invoice-downloads/$id'
      fullPath: '/invoice-downloads/$id'
      preLoaderRoute: typeof InvoiceDownloadsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/new': {
      id: '/invitations/new'
      path: '/invitations/new'
      fullPath: '/invitations/new'
      preLoaderRoute: typeof InvitationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation/$token': {
      id: '/invitation/$token'
      path: '/invitation/$token'
      fullPath: '/invitation/$token'
      preLoaderRoute: typeof InvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/skimmer': {
      id: '/integrations/skimmer'
      path: '/integrations/skimmer'
      fullPath: '/integrations/skimmer'
      preLoaderRoute: typeof IntegrationsSkimmerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/housecall-pro': {
      id: '/integrations/housecall-pro'
      path: '/integrations/housecall-pro'
      fullPath: '/integrations/housecall-pro'
      preLoaderRoute: typeof IntegrationsHousecallProRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/coldstandard': {
      id: '/integrations/coldstandard'
      path: '/integrations/coldstandard'
      fullPath: '/integrations/coldstandard'
      preLoaderRoute: typeof IntegrationsColdstandardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funding/transactions': {
      id: '/funding/transactions'
      path: '/transactions'
      fullPath: '/funding/transactions'
      preLoaderRoute: typeof FundingTransactionsRouteImport
      parentRoute: typeof FundingRoute
    }
    '/funding/link-account': {
      id: '/funding/link-account'
      path: '/link-account'
      fullPath: '/funding/link-account'
      preLoaderRoute: typeof FundingLinkAccountRouteImport
      parentRoute: typeof FundingRoute
    }
    '/cashflow-report-downloads/$id': {
      id: '/cashflow-report-downloads/$id'
      path: '/cashflow-report-downloads/$id'
      fullPath: '/cashflow-report-downloads/$id'
      preLoaderRoute: typeof CashflowReportDownloadsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback/plaid': {
      id: '/callback/plaid'
      path: '/callback/plaid'
      fullPath: '/callback/plaid'
      preLoaderRoute: typeof CallbackPlaidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback/astra': {
      id: '/callback/astra'
      path: '/callback/astra'
      fullPath: '/callback/astra'
      preLoaderRoute: typeof CallbackAstraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tags/': {
      id: '/settings/tags/'
      path: '/settings/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof SettingsTagsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/roles/': {
      id: '/settings/roles/'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof SettingsRolesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payout-policies/': {
      id: '/settings/payout-policies/'
      path: '/settings/payout-policies'
      fullPath: '/settings/payout-policies'
      preLoaderRoute: typeof SettingsPayoutPoliciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications/': {
      id: '/settings/notifications/'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/unpaid-completed-work/': {
      id: '/reporting/unpaid-completed-work/'
      path: '/reporting/unpaid-completed-work'
      fullPath: '/reporting/unpaid-completed-work'
      preLoaderRoute: typeof ReportingUnpaidCompletedWorkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/notifications/': {
      id: '/profile/notifications/'
      path: '/profile/notifications'
      fullPath: '/profile/notifications'
      preLoaderRoute: typeof ProfileNotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/': {
      id: '/opps/$oppId/'
      path: '/opps/$oppId'
      fullPath: '/opps/$oppId'
      preLoaderRoute: typeof OppsOppIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funding/receivables/': {
      id: '/funding/receivables/'
      path: '/receivables'
      fullPath: '/funding/receivables'
      preLoaderRoute: typeof FundingReceivablesIndexRouteImport
      parentRoute: typeof FundingRoute
    }
    '/staff/$id/edit': {
      id: '/staff/$id/edit'
      path: '/staff/$id/edit'
      fullPath: '/staff/$id/edit'
      preLoaderRoute: typeof StaffIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payout-policies/new': {
      id: '/settings/payout-policies/new'
      path: '/settings/payout-policies/new'
      fullPath: '/settings/payout-policies/new'
      preLoaderRoute: typeof SettingsPayoutPoliciesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payout-policies/$id': {
      id: '/settings/payout-policies/$id'
      path: '/settings/payout-policies/$id'
      fullPath: '/settings/payout-policies/$id'
      preLoaderRoute: typeof SettingsPayoutPoliciesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roster/organizations/$id': {
      id: '/roster/organizations/$id'
      path: '/roster/organizations/$id'
      fullPath: '/roster/organizations/$id'
      preLoaderRoute: typeof RosterOrganizationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roster/$id/edit': {
      id: '/roster/$id/edit'
      path: '/roster/$id/edit'
      fullPath: '/roster/$id/edit'
      preLoaderRoute: typeof RosterIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payouts/categories/$category': {
      id: '/payouts/categories/$category'
      path: '/payouts/categories/$category'
      fullPath: '/payouts/categories/$category'
      preLoaderRoute: typeof PayoutsCategoriesCategoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payout-requests/direct/$id': {
      id: '/payout-requests/direct/$id'
      path: '/payout-requests/direct/$id'
      fullPath: '/payout-requests/direct/$id'
      preLoaderRoute: typeof PayoutRequestsDirectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payout-requests/categories/$category': {
      id: '/payout-requests/categories/$category'
      path: '/payout-requests/categories/$category'
      fullPath: '/payout-requests/categories/$category'
      preLoaderRoute: typeof PayoutRequestsCategoriesCategoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/categories/$category': {
      id: '/opps/categories/$category'
      path: '/opps/categories/$category'
      fullPath: '/opps/categories/$category'
      preLoaderRoute: typeof OppsCategoriesCategoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funding/receivables/$payoutId': {
      id: '/funding/receivables/$payoutId'
      path: '/receivables/$payoutId'
      fullPath: '/funding/receivables/$payoutId'
      preLoaderRoute: typeof FundingReceivablesPayoutIdRouteImport
      parentRoute: typeof FundingRoute
    }
    '/funding/accounts/$accountId': {
      id: '/funding/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/funding/accounts/$accountId'
      preLoaderRoute: typeof FundingAccountsAccountIdRouteImport
      parentRoute: typeof FundingRoute
    }
    '/settings/roles/$id/': {
      id: '/settings/roles/$id/'
      path: '/settings/roles/$id'
      fullPath: '/settings/roles/$id'
      preLoaderRoute: typeof SettingsRolesIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payout-requests/reimbursement/$id/': {
      id: '/payout-requests/reimbursement/$id/'
      path: '/payout-requests/reimbursement/$id'
      fullPath: '/payout-requests/reimbursement/$id'
      preLoaderRoute: typeof PayoutRequestsReimbursementIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payout-requests/fsm/$id/': {
      id: '/payout-requests/fsm/$id/'
      path: '/payout-requests/fsm/$id'
      fullPath: '/payout-requests/fsm/$id'
      preLoaderRoute: typeof PayoutRequestsFsmIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/edit/': {
      id: '/opps/$oppId/edit/'
      path: '/opps/$oppId/edit'
      fullPath: '/opps/$oppId/edit'
      preLoaderRoute: typeof OppsOppIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opportunity-claims/$claimId/timeline/': {
      id: '/opportunity-claims/$claimId/timeline/'
      path: '/opportunity-claims/$claimId/timeline'
      fullPath: '/opportunity-claims/$claimId/timeline'
      preLoaderRoute: typeof OpportunityClaimsClaimIdTimelineIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/roles/$id/edit': {
      id: '/settings/roles/$id/edit'
      path: '/settings/roles/$id/edit'
      fullPath: '/settings/roles/$id/edit'
      preLoaderRoute: typeof SettingsRolesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/edit/success': {
      id: '/opps/$oppId/edit/success'
      path: '/opps/$oppId/edit/success'
      fullPath: '/opps/$oppId/edit/success'
      preLoaderRoute: typeof OppsOppIdEditSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/edit/signup': {
      id: '/opps/$oppId/edit/signup'
      path: '/opps/$oppId/edit/signup'
      fullPath: '/opps/$oppId/edit/signup'
      preLoaderRoute: typeof OppsOppIdEditSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/edit/set-rates': {
      id: '/opps/$oppId/edit/set-rates'
      path: '/opps/$oppId/edit/set-rates'
      fullPath: '/opps/$oppId/edit/set-rates'
      preLoaderRoute: typeof OppsOppIdEditSetRatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/edit/proof-of-work': {
      id: '/opps/$oppId/edit/proof-of-work'
      path: '/opps/$oppId/edit/proof-of-work'
      fullPath: '/opps/$oppId/edit/proof-of-work'
      preLoaderRoute: typeof OppsOppIdEditProofOfWorkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/edit/participation': {
      id: '/opps/$oppId/edit/participation'
      path: '/opps/$oppId/edit/participation'
      fullPath: '/opps/$oppId/edit/participation'
      preLoaderRoute: typeof OppsOppIdEditParticipationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/edit/invite': {
      id: '/opps/$oppId/edit/invite'
      path: '/opps/$oppId/edit/invite'
      fullPath: '/opps/$oppId/edit/invite'
      preLoaderRoute: typeof OppsOppIdEditInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opps/$oppId/edit/detail': {
      id: '/opps/$oppId/edit/detail'
      path: '/opps/$oppId/edit/detail'
      fullPath: '/opps/$oppId/edit/detail'
      preLoaderRoute: typeof OppsOppIdEditDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface FundingRouteChildren {
  FundingLinkAccountRoute: typeof FundingLinkAccountRoute
  FundingTransactionsRoute: typeof FundingTransactionsRoute
  FundingIndexRoute: typeof FundingIndexRoute
  FundingAccountsAccountIdRoute: typeof FundingAccountsAccountIdRoute
  FundingReceivablesPayoutIdRoute: typeof FundingReceivablesPayoutIdRoute
  FundingReceivablesIndexRoute: typeof FundingReceivablesIndexRoute
}

const FundingRouteChildren: FundingRouteChildren = {
  FundingLinkAccountRoute: FundingLinkAccountRoute,
  FundingTransactionsRoute: FundingTransactionsRoute,
  FundingIndexRoute: FundingIndexRoute,
  FundingAccountsAccountIdRoute: FundingAccountsAccountIdRoute,
  FundingReceivablesPayoutIdRoute: FundingReceivablesPayoutIdRoute,
  FundingReceivablesIndexRoute: FundingReceivablesIndexRoute,
}

const FundingRouteWithChildren =
  FundingRoute._addFileChildren(FundingRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BatchProcessesRoute: BatchProcessesRoute,
  DashboardRoute: DashboardRoute,
  DevToolsRoute: DevToolsRoute,
  FundingRoute: FundingRouteWithChildren,
  HomeRoute: HomeRoute,
  JoinRequestsRoute: JoinRequestsRoute,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  ReferralsRoute: ReferralsRoute,
  TermsAcceptanceRoute: TermsAcceptanceRoute,
  CallbackAstraRoute: CallbackAstraRoute,
  CallbackPlaidRoute: CallbackPlaidRoute,
  CashflowReportDownloadsIdRoute: CashflowReportDownloadsIdRoute,
  IntegrationsColdstandardRoute: IntegrationsColdstandardRoute,
  IntegrationsHousecallProRoute: IntegrationsHousecallProRoute,
  IntegrationsSkimmerRoute: IntegrationsSkimmerRoute,
  InvitationTokenRoute: InvitationTokenRoute,
  InvitationsNewRoute: InvitationsNewRoute,
  InvoiceDownloadsIdRoute: InvoiceDownloadsIdRoute,
  OppsNewRoute: OppsNewRoute,
  OppsTemplatesRoute: OppsTemplatesRoute,
  OrganizationsEditRoute: OrganizationsEditRoute,
  PayoutReportDownloadsIdRoute: PayoutReportDownloadsIdRoute,
  PayoutRequestsIdRoute: PayoutRequestsIdRoute,
  PayoutsPayoutIdRoute: PayoutsPayoutIdRoute,
  ReportingCashflowRoute: ReportingCashflowRoute,
  ReportingPayoutsRoute: ReportingPayoutsRoute,
  RosterAddRoute: RosterAddRoute,
  SystemClassifyDomainRoute: SystemClassifyDomainRoute,
  SystemOrglessAccountsRoute: SystemOrglessAccountsRoute,
  UnpaidCompletedWorkReportDownloadsIdRoute:
    UnpaidCompletedWorkReportDownloadsIdRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  InvitationsIndexRoute: InvitationsIndexRoute,
  OppsIndexRoute: OppsIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  PayoutRequestsIndexRoute: PayoutRequestsIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  ReportingIndexRoute: ReportingIndexRoute,
  RosterIndexRoute: RosterIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  StaffIndexRoute: StaffIndexRoute,
  OppsCategoriesCategoryRoute: OppsCategoriesCategoryRoute,
  PayoutRequestsCategoriesCategoryRoute: PayoutRequestsCategoriesCategoryRoute,
  PayoutRequestsDirectIdRoute: PayoutRequestsDirectIdRoute,
  PayoutsCategoriesCategoryRoute: PayoutsCategoriesCategoryRoute,
  RosterIdEditRoute: RosterIdEditRoute,
  RosterOrganizationsIdRoute: RosterOrganizationsIdRoute,
  SettingsPayoutPoliciesIdRoute: SettingsPayoutPoliciesIdRoute,
  SettingsPayoutPoliciesNewRoute: SettingsPayoutPoliciesNewRoute,
  StaffIdEditRoute: StaffIdEditRoute,
  OppsOppIdIndexRoute: OppsOppIdIndexRoute,
  ProfileNotificationsIndexRoute: ProfileNotificationsIndexRoute,
  ReportingUnpaidCompletedWorkIndexRoute:
    ReportingUnpaidCompletedWorkIndexRoute,
  SettingsNotificationsIndexRoute: SettingsNotificationsIndexRoute,
  SettingsPayoutPoliciesIndexRoute: SettingsPayoutPoliciesIndexRoute,
  SettingsRolesIndexRoute: SettingsRolesIndexRoute,
  SettingsTagsIndexRoute: SettingsTagsIndexRoute,
  OppsOppIdEditDetailRoute: OppsOppIdEditDetailRoute,
  OppsOppIdEditInviteRoute: OppsOppIdEditInviteRoute,
  OppsOppIdEditParticipationRoute: OppsOppIdEditParticipationRoute,
  OppsOppIdEditProofOfWorkRoute: OppsOppIdEditProofOfWorkRoute,
  OppsOppIdEditSetRatesRoute: OppsOppIdEditSetRatesRoute,
  OppsOppIdEditSignupRoute: OppsOppIdEditSignupRoute,
  OppsOppIdEditSuccessRoute: OppsOppIdEditSuccessRoute,
  SettingsRolesIdEditRoute: SettingsRolesIdEditRoute,
  OpportunityClaimsClaimIdTimelineIndexRoute:
    OpportunityClaimsClaimIdTimelineIndexRoute,
  OppsOppIdEditIndexRoute: OppsOppIdEditIndexRoute,
  PayoutRequestsFsmIdIndexRoute: PayoutRequestsFsmIdIndexRoute,
  PayoutRequestsReimbursementIdIndexRoute:
    PayoutRequestsReimbursementIdIndexRoute,
  SettingsRolesIdIndexRoute: SettingsRolesIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
